/**
 * @file Defines the {@link UI_INTERFACES} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Array storing ID's of all interfaces
  */
 const UI_INTERFACES = [

    'autospinContainerMobile',
    'betContainerMobile',

 ]

 export { UI_INTERFACES }